module.exports = __webpack_public_path__ + "img/block_2.d81e995c.png";